import {Autocomplete} from "@mui/lab";
import React, {useEffect, useState} from "react";
import {useProductsState} from "../ProductsContext";
import {SearchSharp} from "@mui/icons-material";
import {FixedSizeList} from "react-window";
import PropTypes from "prop-types";
import {
  autocompleteClasses,
  Box,
  CircularProgress,
  createFilterOptions,
  Popper,
  styled,
  TextField
} from "@mui/material";
import useWindowDimensions from "../Dimension";
import {matchSorter} from "match-sorter";
import {Document} from "flexsearch";

const _filterOptions = createFilterOptions();

export default function ProductSearchBar(props){
  const [selectedProduct, setSelectedProduct] = useState({
    'name': '',
  })
  const [openAutoComplete, setOpenAutoComplete] = useState(false)

  const { windowHeight, windowWidth } = useWindowDimensions();

  const state = useProductsState();
  // const [filtered, setFiltered] = useState([]);

  // const searchDocument = new Document()

  // if(state.data){
  //   searchDocument.addAll()
  // }


  let filtered = []

  function renderRow(props) {
    const { data, index, style } = props;
    return React.cloneElement(data[index], {
      style: {
        ...style,
        top: style.top + 2,
        bottom : style.bottom + 2
      },
    });
  }

  const OuterElementContext = React.createContext({});

  const OuterElementType = React.forwardRef((props, ref) => {
    const outerProps = React.useContext(OuterElementContext);
    return <div ref={ref} {...props} {...outerProps} />;
  });

  const ListboxComponent = React.forwardRef(function ListboxComponent(props, ref) {
    const { children, ...other } = props;
    const itemData = React.Children.toArray(children);
    const itemCount = itemData.length;
    // const itemSize = windowWidth < 1130 ? 72 : 54;
    const itemSize = 54
    // const getChildSize = (child) => {
    //   // if (React.isValidElement(child)) {
    //   //   return 54;
    //   // }
    //
    //   return itemSize;
    // };
    //
    // const getHeight = () => {
    //   if (itemCount > 8) {
    //     return 8 * itemSize;
    //   }
    //   return itemData.map(getChildSize).reduce((a, b) => a + b, 2);
    // };

    return (
      <div ref={ref}>
        <OuterElementContext.Provider value={other}>
          <FixedSizeList
            itemData={itemData}
            height={itemCount > 8 ? itemSize * 8 : itemSize * itemCount}
            width="100%"
            outerElementType={OuterElementType}
            innerElementType="ul"
            itemSize={itemSize}
            overscanCount={0}
            itemCount={itemCount}
          >
            {renderRow}
          </FixedSizeList>
        </OuterElementContext.Provider>
      </div>
    );
  });

  ListboxComponent.propTypes = {
    children: PropTypes.node,
  };


  const StyledPopper = styled(Popper)({
    [`& .${autocompleteClasses.listbox}`]: {
      boxSizing: 'border-box',
      '& ul': {
        padding: 0,
        margin: 0,
      },
    },
  });



  useEffect(() => {
    console.log('selecedProduct', props.selected)
    setSelectedProduct(props.selected)
  }, [props.selected])

  // const filterOptions = useCallback((options, state) => {
  //     const results = _filterOptions(options, state);
  //     console.log('filtered ', results, location.pathname)
  //     if(location.pathname === '/data/manage' && props.onFiltered){
  //       filtered = [...results]
  //       props.onFiltered(results)
  //     }
  //
  //     return results;
  // }, [location.pathname, props.onFiltered])
  const filterOptions = (options, {inputValue}) => {
      // Normalize query by trimming only the leading whitespace to be forgiving to pasted inputs
      const query = (inputValue || '').trimStart();
      let results = matchSorter(options, query, { keys: ['id', 'name', 'opt_code', 'id_fs', 'gsheet_rack_code'] });
    // let results = matchSorter(options, query, { keys: ['name', 'id_fs'] });

    if(props.filterMode && props.onFiltered){
      // filtered = [...results]
      filtered = results

      props.onFiltered(results)
    }

      return results;
  };

  // useEffect(()=>{
  //
  //   let timer
  //   if(props.filterMode && props.onFiltered){
  //     timer = setTimeout(()=>{
  //       props.onFiltered(filtered)
  //     }, 500)
  //   }
  //   return () => {
  //     if(timer){
  //       clearTimeout(timer);
  //     }
  //   }; //value 변경 시점에 clearTimeout을 해줘야함.
  //
  // }, [filtered, props.filterMode, props.onFiltered])
  // const filterOptions = (options, { inputValue }) => matchSorter(options, inputValue, { keys: ['name', 'id_fs'] });

  return(
      <Autocomplete
        id="Product-SearchBar"
        disableListWrap
        PopperComponent={StyledPopper}
        ListboxComponent={ListboxComponent}
        filterOptions={filterOptions}
        loadingText={"불러오는중..."}
        clearOnEscape={true}
        blurOnSelect={true}
        freeSolo={true}
        value={selectedProduct}
        fullWidth={true}
        open={openAutoComplete}
        onOpen={() => {
          // setOpenAutoComplete(true);
        }}
        onClose={() => {
          setOpenAutoComplete(false);
          // setAutoCompleteFocus(false)
          // searchInput.current.focus
        }}
        onChange={(event,value) => {
          // console.log(`onChange ${event} , ${value}`)
          if(value && typeof value === 'object') {
            filtered = []
            props.onSelected(value)
            // props.onBlur()
          }
        }}
        getOptionSelected={(option, value) => {
          // console.log(`${option.name} , ${value.name}`)
          if(option.name != null && value.name != null) {
            return option.name.toLowerCase() === value.name.toLowerCase()
          }

          return false;
        }}
        // onKeyUp={(e) => {
        //   props.onKeyUp(e)
        //   if(e.key === "Enter"){
        //     e.target.blur()
        //   }
        // }}
        onFocus={(event)=>{
          console.log("onFocus event : " + event)
          props.onFocus()
        }}
        onBlur={(event)=>{
          console.log("onBlur event : " + event)
          props.onBlur()
        }}
        onInputChange = {(event, value, reason)=>{
          // console.log("onInputChange event : " + event + ", value : " + value + ", reason : " + reason + ', filterMode : ' + props.filterMode)
          if(reason === 'clear') {
            props.onCleared()
          }else if(reason === 'reset') {
            if(props.filterMode && value === '') {
              console.log('filtered', filtered)
              if(filtered.length > 1) {
                setSelectedProduct({name:  `${filtered[0].name}`, gsheet_rack_code : `외 ${filtered.length}개 결과`})
              }else if(filtered.length === 1){
                setSelectedProduct(filtered[0])
              }
              // filtered = []

            }
            // event.target.blur()
          }
          if(reason === 'input' && Boolean(value)){
            setOpenAutoComplete(true);
          }else{
            setOpenAutoComplete(false);
          }
        }}
        getOptionLabel={(option) => {
          if(Boolean(option) && option.name){
            return (( option.id !== undefined ? ("[" + option.id + "/" + option.opt_code + "/" + option.id_fs + "] ") : '') + option.name + " (" +option.gsheet_rack_code + ")") || ""
          }else{
            return ""
          }
          // return (option.name + " (" +option.gsheet_rack_code + ")") || ""

        }}
        options={props.optionsOverride != null ? props.optionsOverride : (state.data != null ? state.data : [])}
        noOptionsText={"검색결과 없음"}
        loading={props.optionsOverride != null ? false : state.loading}
        // renderOption={(option) => {
        //   console.log('renderOption ', option)
        //   if(Bo olean(option) && option.key){
        //     return <Box sx={{color : 'black'}}>
        //         <p>{option.key}</p>
        //
        //       </Box>
        //   }else{
        //     return <div/>
        //   }
        // }}
        renderInput={(params) => (
          <TextField
            {...params}
            label=""
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment : (
                <React.Fragment>
                  <SearchSharp/>
                  {/*<img*/}
                  {/*  src={"https://media.istockphoto.com/id/1346236801/ko/%EB%B2%A1%ED%84%B0/%ED%88%AC%EB%AA%85-%ED%95%9C-%EB%B0%B0%EA%B2%BD%EC%97%90-%EA%B2%A9%EB%A6%AC-%EB%90%9C-%EB%B2%A1%ED%84%B0-%ED%81%AC%EB%A6%AC%EC%8A%A4%EB%A7%88%EC%8A%A4-%ED%8A%B8%EB%A6%AC-%EB%B3%BC-%ED%99%94%ED%99%98-%EC%A0%84%EA%B5%AC-%EC%A3%BC%EC%84%9D%EA%B3%BC-%EC%83%81%EB%8B%A8%EC%97%90-%ED%99%A9%EA%B8%88-%EB%B3%84-%EC%9E%A5%EC%8B%9D%EC%95%84%EB%A6%84%EB%8B%A4%EC%9A%B4-%EB%B9%9B%EB%82%98%EB%8A%94-%ED%81%AC%EB%A6%AC%EC%8A%A4%EB%A7%88%EC%8A%A4-%ED%8A%B8%EB%A6%AC-%EC%82%AC%EC%8B%A4%EC%A0%81%EC%9D%B8-%EC%8A%A4%ED%83%80%EC%9D%BC-eps-10.jpg?s=612x612&w=0&k=20&c=h630xnG1BdH0HEj31GHcCfZ5eJ5HKa8JEc8npEiuyvs="}*/}
                  {/*  height={38}/>*/}
                </React.Fragment>
              ),
              endAdornment: (
                <React.Fragment>
                  {state.loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
  )
}